import { gql } from "@apollo/client";

export const NOTIFICATIONS_COUNT = gql`
  query NotificationsCount {
    notificationCount
  }
`;
